const productsSwatches = document.querySelectorAll('.product-container .product__color-swatch');

productsSwatches.forEach(productSwatch => {
  productSwatch.addEventListener('click', () => {
    const productContainer = productSwatch.closest('.product-container');


    if (productContainer) {
      const index = productSwatch.getAttribute('data-index');

      const images = productContainer.querySelectorAll('.image img');

      const variantImage = images[index - 1];

      images.forEach(image => {
        if (!image.classList.contains('hover')) {
          image.classList.add('hidden');
        }
      });

      variantImage.classList.remove('hidden');
    }
  });
});

const dynamicVariantInputs = document.querySelectorAll('.dynamic-variant-input');

dynamicVariantInputs.forEach(dynamicVariantInput => {
  dynamicVariantInput.addEventListener('change', () => {
    const productContainer = dynamicVariantInput.closest('.product-container');

    if (productContainer) {
      const index = dynamicVariantInput.selectedIndex; // Get the index of the selected option

      const images = productContainer.querySelectorAll('.image img');

      const variantImage = images[index]; // Use index directly, no need for -1 as `selectedIndex` is zero-based

      images.forEach(image => {
        if (!image.classList.contains('hover')) {
          image.classList.add('hidden');
        }
      });

      if (variantImage) {
        variantImage.classList.remove('hidden');
      }
    }
  });
});
